<template>
  <router-view/>
  <LeFootah/>
</template>

<script>
import LeFootah from "@/components/LeFootah.vue";

export default {
  name: "AppHome",

  components: {
    LeFootah
  },
}
</script>

<style>
@import "assets/font_main/stylesheet.css";
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');

html, body {
  padding: 0 !important;
  margin: 0 !important;
  background: #1e1e1e;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-view {
  width: 100%;
  height: 100vh;
}

.app-view.fix-sticky {
  margin-top: -66px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
